import { BaseExternalEvent } from '../types';
import { randomId } from './core.utils';

export function buildExternalEvent<T extends BaseExternalEvent>(part: Partial<T> & Pick<T, 'type'>): T {
  return {
    id: `external-event-${part.type}-${randomId()}`,
    ...part,
  } as T;
}
